import { render, staticRenderFns } from "./greenLowCarbon.vue?vue&type=template&id=23d16b97&scoped=true&"
import script from "./greenLowCarbon.vue?vue&type=script&lang=js&"
export * from "./greenLowCarbon.vue?vue&type=script&lang=js&"
import style0 from "./greenLowCarbon.vue?vue&type=style&index=0&id=23d16b97&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d16b97",
  null
  
)

export default component.exports